import { getAllImageStore, setImageEntry } from "./indexedDBHelper";
import { base64ToBlob } from "./resizeImage";

export const migrateBase64ToBlob = async () => {
  const imageStore = await getAllImageStore();
  // console.log(imageStore, "migrateBase64ToBlob imageStore");
  for (let id in imageStore) {
    // console.log(id, "migrating image for id");
    const entry = imageStore[id];
    // console.log(entry,"entry")
    if (typeof entry.imageUrl === "string") { 
      const blob = base64ToBlob(entry.imageUrl);
      await setImageEntry({ ...entry, imageUrl: blob });
    }
  }
};
